import {inject} from '@angular/core';
import {CanActivateFn} from '@angular/router';
import {firstValueFrom, isObservable} from 'rxjs';
import {authGuard} from '../../auth/auth.guard';
import {ApiCompatibilityService} from './api-compatibility.service';

export const apiCompatibilityGuard: CanActivateFn = async (route, state) => {
  const compatibility = inject(ApiCompatibilityService);
  const authResult = authGuard(route, state);
  const authenticated = isObservable(authResult) ? await firstValueFrom(authResult) : await authResult;
  return authenticated === true ? compatibility.waitUntilCompatible() : authenticated;
};
